import React from 'react';
import { VStack, StackProps } from '@chakra-ui/react';

export function CardPanel({ children, ...props }: StackProps) {
	return (
		<VStack bg={{ base: '{colors.neutral.100}', _dark: '{colors.neutral.800}' }} borderRadius={'md'} boxShadow={'sm'} justifyContent={'center'} padding={'4'} {...props} >
			{children}
		</VStack>
	);
}